// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","brand":"Nav_brand__l84Tq","navlinks":"Nav_navlinks__MHyQb","addExp":"Nav_addExp__kjTHl","dropDown":"Nav_dropDown__oZ7p4","user":"Nav_user__Ge+XO"};